module.exports = __webpack_public_path__ + "media/icons/people-8db0fa49.png";